/**
 * North Korean won.
 */
export var KPW = {
  code: 'KPW',
  base: 10,
  exponent: 2
};